import styled from "styled-components";
import { lighten } from "polished";

import { IHandSignButtonProps } from "./interfaces";

export const HandSignButton = styled.button<IHandSignButtonProps>`
    margin: 16px;
    border: none;
    background-color: transparent;
    outline: none;
    padding: 0;
    transform-origin: center;
    cursor: pointer;
    transition: 300ms, transform 200ms;

    svg {
        width: 64px;
        height: 64px;
        display: block;

        .sleeve {
            fill: ${p => p.theme.c.whiteOnActive};
        }
        .fill {
            fill: ${p => (p.coloring ? p.theme.c.solfa[p.solfaShort] : p.theme.c.white)};
        }
    }

    &.HalfStep {
        margin-top: -10px;
    }

    &.Invisible {
        pointer-events: none;
        visibility: hidden;
    }

    &.Disabled {
        opacity: 0.4;
        pointer-events: none;
    }

    &.Sharpened {
        transform: translateY(-26px);
    }
    &.Flatened {
        transform: translateY(26px);
    }

    &:active {
        transform: scale(1.1);
    }

    &.Sharpened:active {
        transform: translateY(-26px) scale(1.1);
    }
    &.Flatened:active {
        transform: translateY(26px) scale(1.1);
    }
`;

export const Scroll = styled.div`
    overflow-y: auto;
    height: 100%;
    display: flex;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        width: 8px;
        height: 12px;
        background-color: ${p => p.theme.c.greyE}; /* or add it to the track */
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${p => lighten(0.04, p.theme.c.pale)};
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column-reverse;
    margin: auto;
`;
